import React from 'react';
import { AffiliateDashboard } from '../components/AffiliateDashboard.tsx';
import { TrendingUp } from 'lucide-react';

export const AffiliateDashboardPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <TrendingUp className="h-8 w-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">Affiliate Program</h1>
          </div>
          <p className="text-gray-600">
            Earn 1% commission on every trade placed by users you invite to Wayja.
          </p>
        </div>

        {/* Affiliate Dashboard Component */}
        <AffiliateDashboard />
      </div>
    </div>
  );
}; 